import apiClient from './apiConfig';

const hotSectionsApi = {
  // Lấy tất cả section (admin)
  getAll: async (params = "") => {
    const response = await apiClient.get(`/hot-sections${params}`);
    return response.data;
  },

  // Lấy 1 section theo id
  getById: async (id) => {
    const response = await apiClient.get(`/hot-sections/${id}`);
    return response.data;
  },

  // Tạo mới
  create: async (data) => {
    const response = await apiClient.post('/hot-sections', data);
    return response.data;
  },

  // Cập nhật
  update: async (id, data) => {
    const response = await apiClient.put(`/hot-sections/${id}`, data);
    return response.data;
  },

  // Xoá
  remove: async (id) => {
    const response = await apiClient.delete(`/hot-sections/${id}`);
    return response.data;
  },

  // Sắp xếp lại thứ tự nhiều section
  reorder: async (orders) => {
    const response = await apiClient.put('/hot-sections/reorder/all', { orders });
    return response.data;
  },
};

export default hotSectionsApi;
